import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { ChevronDown, ChevronUp, Settings2, RotateCcw } from "lucide-react";
import { MetricConfig } from "@/hooks/gym-stats/useGymMetricsConfig";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
interface MetricsSelectorProps {
  metrics: MetricConfig[];
  onToggleMetric: (metricId: string) => void;
  onReset: () => void;
}
const CATEGORY_LABELS: Record<MetricConfig["category"], string> = {
  kpi: "KPIs Principales",
  financial: "Métricas Financieras",
  classes: "Métricas de Clases",
  visualization: "Visualizaciones"
};
const CATEGORY_ORDER: MetricConfig["category"][] = ["kpi", "financial", "classes", "visualization"];
export const MetricsSelector = ({
  metrics,
  onToggleMetric,
  onReset
}: MetricsSelectorProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const getMetricsByCategory = (category: MetricConfig["category"]) => {
    return metrics.filter(m => m.category === category);
  };
  return <Card className="border-border/50 bg-card/50 backdrop-blur-sm">
      <Collapsible open={isOpen} onOpenChange={setIsOpen}>
        <CollapsibleTrigger asChild>
          <CardHeader className="cursor-pointer hover:bg-muted/30 transition-colors py-3">
            <div className="flex items-center justify-between">
              <CardTitle className="text-base flex items-center gap-2">
                <Settings2 className="h-4 w-4 text-primary" />
                Personalizar Métricas
              </CardTitle>
              <div className="flex items-center gap-2">
                <span className="text-xs text-muted-foreground pl-[6px]">
                  {metrics.filter(m => m.enabled).length} activas
                </span>
                {isOpen ? <ChevronUp className="h-4 w-4 text-muted-foreground" /> : <ChevronDown className="h-4 w-4 text-muted-foreground" />}
              </div>
            </div>
          </CardHeader>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <CardContent className="pt-0 pb-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {CATEGORY_ORDER.map(category => {
              const categoryMetrics = getMetricsByCategory(category);
              if (categoryMetrics.length === 0) return null;
              return <div key={category} className="space-y-3">
                    <h4 className="text-sm font-medium text-foreground border-b border-border/30 pb-2">
                      {CATEGORY_LABELS[category]}
                    </h4>
                    <div className="grid grid-cols-1 gap-2">
                      {categoryMetrics.map(metric => <label key={metric.id} className="flex items-center gap-3 p-2 rounded-lg hover:bg-muted/30 cursor-pointer transition-colors">
                          <Checkbox checked={metric.enabled} onCheckedChange={() => onToggleMetric(metric.id)} className="data-[state=checked]:bg-primary data-[state=checked]:border-primary" />
                          <span className="text-sm text-foreground">{metric.label}</span>
                        </label>)}
                    </div>
                  </div>;
            })}
            </div>
            <div className="mt-4 pt-4 border-t border-border/30 flex justify-end">
              <Button variant="outline" size="sm" onClick={onReset} className="text-muted-foreground hover:text-foreground">
                <RotateCcw className="h-3 w-3 mr-2" />
                Restablecer
              </Button>
            </div>
          </CardContent>
        </CollapsibleContent>
      </Collapsible>
    </Card>;
};